import { Link } from "react-router-dom";
import { works } from "@/mocks/works";
import WorkCard from "@/components/feature/WorkCard";

export default function FeaturedSection() {
  const featured = [...works].sort((a, b) => b.heat - a.heat).slice(0, 5);

  return (
    <section className="bg-background-100 py-14 md:py-20" aria-labelledby="featured-heading">
      <div className="container-x">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="text-xs font-semibold uppercase tracking-wider text-primary-600">
              热门推荐
            </span>
            <h2 id="featured-heading" className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              大家都在看的同人
            </h2>
          </div>
          <Link
            to="/category/chuanyue"
            className="hidden items-center gap-1 text-sm font-medium whitespace-nowrap text-foreground-600 hover:text-primary-700 md:inline-flex"
          >
            更多推荐 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5">
          {featured.map((w) => (
            <WorkCard key={w.id} work={w} />
          ))}
        </div>
      </div>
    </section>
  );
}